<template>
  <div class="contentHome">
    <div class="centerPage">
      <div class="leftCon">
        <el-carousel :interval="5000" arrow="always" indicator-position="none" height="333px" class="carousel">
          <el-carousel-item v-for="(item,ind) in psychologicalBanner" :key="ind">
            <div class="img" :style="'backgroundImage: url('+item.exhibitImg+')'">
              <div style="position:relative;top:20%;left:4%;color: #fff;">
                <div style="font-size: 22px;font-weight: bold;margin-bottom: 10px">{{ item.title }}</div>
                <div style="font-size: 14px">{{ item.subTitle }}</div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
        <el-tabs v-model="activeName" class="types" @tab-click="switchType">
          <el-tab-pane :label="obj.itemName" :name="obj.id.toString()" v-for="(obj,index) in types"
                       :key="index">
            <div class="list" v-for="(item,ind) in obj.list" :key="ind" @click="toDetail(item.id)">
              <div :style="item.exhibitImg?'backgroundImage: url('+item.exhibitImg+')':''"
                   class="listImg"></div>
              <div class="listRight">
                <h4>{{ item.title }}</h4>
                <p>{{ item.description }}</p>
                <div class="date">
                  <span v-if="item.price>0">￥<span>{{ item.price }}</span></span>
                  <span v-if="item.price==0"><span>免费</span></span>
                  <span>{{ item.testedCount }}人已测</span>
                  <span>{{ item.msgCount }}人评论</span>
                  <span>{{ item.exceptTime }}</span>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
        <el-pagination
            background
            prev-text="Prev"
            next-text="Next"
            class="pagination"
            layout="prev, pager, next, total"
            @current-change="skipPage"
            :hide-on-single-page="true"
            :page-size="page.size"
            :current-page="page.current"
            :total="page.total">
        </el-pagination>
      </div>
      <div class="rightCon">
        <div class="tab">
          <h3 class="tit">热门测试</h3>
          <div class="popularTest">
            <el-tooltip class="item" v-for="(item,ind) in popularTest" :key="ind"
                        effect="dark" :content="item.title" placement="bottom-start">
              <span class="overFlow" @click="toDetail(item.id)">{{ item.title }}</span>
            </el-tooltip>
          </div>
        </div>
        <div class="tab">
          <h3 class="tit">新型测试</h3>
          <div class="popularTest">
            <el-tooltip class="item" v-for="(item,ind) in newTest" :key="ind"
                        effect="dark" :content="item.title" placement="bottom-start">
              <span class="overFlow" @click="toDetail(item.id)">{{ item.title }}</span>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import base from '@/api/common'

export default {
  name: "exam",
  data() {
    return {
      psychologicalBanner: [],
      activeName: '0',
      types: [{
        id: 0,
        itemName: '精选',
        list: []
      }],
      page: {
        current: 1,
        size: 5,
        total: 20,
        type: 0,
        index: 0,
      },
      popularTest: [],
      newTest: []
    }
  },
  mounted() {
    // 推荐内容
    this.$ajax.get(base.api.recommend.exam).then((res) => {
      if (res.data.status === 'success') {
        this.psychologicalBanner = res.data.list;
      }
    });
    // 侧边top
    this.$ajax.get(base.api.exam.top).then((res) => {
      if (res.data.status === 'success') {
        // 限制最多6个
        this.popularTest = res.data.hotList.slice(0, 6);
        this.newTest = res.data.newList.slice(0, 6);
      }
    })
    // 筛选类型
    this.$ajax.get(base.api.dict.exam.type).then((res) => {
      if (res.data.status === 'success') {
        this.types = this.types.concat(res.data.list);
      }
    })
    // 最后加载list
    this.getData();
  },
  methods: {
    getData(options) {
      if (!options) {
        options = {
          page: 1,
          size: 5,
          type: 0,
          index: 0,
        };
      }
      this.$ajax.get(base.api.exam.list, {params: options}).then((res) => {
        if (res.data.status === 'success') {
          this.types[options.index].list = res.data.rows;
          this.page.current = res.data.current;
          this.page.size = res.data.size;
          this.page.total = res.data.total;
          this.page.type = options.type;
          this.page.index = options.index;
        }
      })
    },
    toDetail(id) {
      this.$router.push({name: 'examDetail', query: {back: '1', id: id}});
    },
    switchType(tab, event) {
      let index = tab.index;
      let type = tab.name;
      this.page = {
        type: type,
        current: 1,
        size: 5,
        total: 21,
      };
      this.getData({
        page: 1,
        size: 5,
        type: type,
        index: index
      });

    },
    skipPage(current) {
      this.getData({
        page: current,
        size: 5,
        type: this.page.type,
        index: this.page.index
      });
      this.$nextTick(() => {
        $(".contentIndex").animate({scrollTop: '0px'}, 800);
      });
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/psychological.scss";

.contentHome {
  //background: url("~@/assets/img/psy_b.png") no-repeat right 60%;
  background-size: 552px;

  .centerPage {
    display: flex;
  }

  ::v-deep .el-pagination {
    margin-top: 20px;
  }
}
</style>